export const HALF_G = '1/2g'
export const EIGHTH = '1/8'
export const QUARTER = '1/4'
export const HALF = '1/2'
export const G = '1g'

export default { HALF_G, EIGHTH, QUARTER, HALF, G }
